var unitPrice = "{{ pricePerUnit }} each";
var unitsCount = "{{ unitsCount }} units";
var unitCount = "{{ unitsCount }} unit";
var unitPriceWithQuantity = "{{ pricePerUnit }} each / {{ unitsCount }} units";
var vatInclusive = "Incl. VAT";
var vatExclusive = "Excl. VAT";
var excludeShipping = "Excl. {{ shipping }}";
var includeShipping = "Incl. {{ shipping }}";
var shipping = "delivery";
var vatAndShipping = {
	includeVatExcludeShipping: "Incl. VAT, excl. {{ shipping }}",
	excludeVatIncludeShipping: "Excl. VAT, incl. {{ shipping }}",
	includeVatIncludeShipping: "Incl. VAT, incl. {{ shipping }}",
	excludeVatExcludeShipping: "Excl. VAT, excl. {{ shipping }}"
};
var priceSummary = "Price summary";
var priceSummaryInfoIcon = "Price summary info icon";
var priceSummaryModal = "Price summary modal";
var priceSummaryCloseModal = "Close price summary modal";
var priceSummaryTermsAndConditions = "*For each order, a unique screen or pad is made and equipment is adjusted to print your design. ";
var priceSummaryBasePrice = "Base price";
var priceSummarySetupFee = "Setup fee*";
var priceSummarySubtotal = "Subtotal";
var differentialPrice = {
	included: "Included",
	forUnits: "{{ differentialPrice }} for {{ quantity }} units",
	forUnit: "{{ differentialPrice }} for {{ quantity }} unit"
};
var priceFrom = "From {{ price }}";
var volumeDiscount = "{{volumeDiscount}}% Volume Discount";
var volumeDiscountPlusSale = "{{volumeDiscount}}% Volume Discount + Sale";
var rangePrice = "{{xx}} - {{yy}}";
var unitRangePrice = "{{rangePrice}} each";
var originalPrice = "original price:";
var salePrice = "current sale price:";
var setupFee = "{{ setupFee }} setup fee applies";
var noSetupFee = "No set-up fee";
var vatAndSetupFee = {
	noVatInclSetup: "Incl. {{ setupFee }} setup fee",
	inclVatAndSetup: "Incl. {{ setupFee }} setup fee and VAT",
	exclVatInclSetup: "Incl. {{ setupFee }} setup fee, excl. VAT",
	inclVatSetupInclShipping: "Incl. {{ setupFee }} setup fee and VAT, incl. {{ shipping }}",
	inclVatSetupExclShipping: "Incl. {{ setupFee }} setup fee and VAT, excl. {{ shipping }}",
	exclVatSetupInclShipping: "Incl. {{ setupFee }} setup fee, excl. VAT, incl. {{ shipping }}",
	exclVatSetupExclShipping: "Incl. {{ setupFee }} setup fee, excl. VAT and {{ shipping }}"
};
var engb = {
	unitPrice: unitPrice,
	unitsCount: unitsCount,
	unitCount: unitCount,
	unitPriceWithQuantity: unitPriceWithQuantity,
	vatInclusive: vatInclusive,
	vatExclusive: vatExclusive,
	excludeShipping: excludeShipping,
	includeShipping: includeShipping,
	shipping: shipping,
	vatAndShipping: vatAndShipping,
	priceSummary: priceSummary,
	priceSummaryInfoIcon: priceSummaryInfoIcon,
	priceSummaryModal: priceSummaryModal,
	priceSummaryCloseModal: priceSummaryCloseModal,
	priceSummaryTermsAndConditions: priceSummaryTermsAndConditions,
	priceSummaryBasePrice: priceSummaryBasePrice,
	priceSummarySetupFee: priceSummarySetupFee,
	priceSummarySubtotal: priceSummarySubtotal,
	differentialPrice: differentialPrice,
	priceFrom: priceFrom,
	volumeDiscount: volumeDiscount,
	volumeDiscountPlusSale: volumeDiscountPlusSale,
	rangePrice: rangePrice,
	unitRangePrice: unitRangePrice,
	originalPrice: originalPrice,
	salePrice: salePrice,
	setupFee: setupFee,
	noSetupFee: noSetupFee,
	vatAndSetupFee: vatAndSetupFee
};

export { engb as default, differentialPrice, excludeShipping, includeShipping, noSetupFee, originalPrice, priceFrom, priceSummary, priceSummaryBasePrice, priceSummaryCloseModal, priceSummaryInfoIcon, priceSummaryModal, priceSummarySetupFee, priceSummarySubtotal, priceSummaryTermsAndConditions, rangePrice, salePrice, setupFee, shipping, unitCount, unitPrice, unitPriceWithQuantity, unitRangePrice, unitsCount, vatAndSetupFee, vatAndShipping, vatExclusive, vatInclusive, volumeDiscount, volumeDiscountPlusSale };
//# sourceMappingURL=ep-pricing-esm-localization-texts-en-gb.json.js.map
